import React, { useState } from "react";
import "../css/Book.css";
import Menu from "./Menu";
import Nav from "./Nav";
import "../css/Details.css";
import Location from "./Location";
import title from "./title.png";
import PhoneIcon from "@material-ui/icons/Phone";
import HomeIcon from "@material-ui/icons/Home";
import Slideshow from "./Slideshow";
import AllCards from "./AllCards";
import photo from './images/photo.jpeg'
import Banner from "./Banner";

function Details() {
  return (
    <div>
      <Nav />
      <center>
        <div>
          <Banner/>
          <div className="background">
            <div id="details-container">
              <div>
                <div class="row">
                <div class="column slideshow-container">
                   <Slideshow/>
                  </div>
                  <div class="column">
                    <div class="para">
                      <p class="info">
                        <h3 id="heading">Details</h3>
                        <li class="bullet"> M.B.B.S (Cal) </li>

                        <li class="bullet">M.D (Cal)</li>

                        <li class="bullet">DCH (Cal)</li>

                        <li class="bullet"> PGPN (BOSTON USA)</li>

                        <li class="bullet">
                          Ex- House Staff Calcutta Medical College
                        </li>

                        <li class="bullet">
                          Life Member of Indian Academy of Paediatrics{" "}
                        </li>

                        <li class="bullet">
                          Life Member of Indian Medial Association
                        </li>

                      
                      </p>
                    </div>
                  </div>
                 
                </div>
              </div>
            </div>
          </div>
        </div>
        <AllCards/>
      </center>
    </div>
  );
}

export default Details;
